import { type ReactElement } from "react";

type TProps = {
  children: ReactElement;
};

export function PublicRoute({ children }: TProps) {
  return children;
}
